import { useEffect } from "react";

const Reviews = () => {
    useEffect(() => {
        if (document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
            return;
        }

        const script = document.createElement("script");
        script.src = "https://elfsightcdn.com/platform.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <section className="w-full bg-white py-16 sm:py-20 lg:py-28">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="elfsight-app-49761f08-cb9a-4a46-9c37-cf5811147b91" data-elfsight-app-lazy="" />
            </div>
        </section>
    );
};

export default Reviews;
